import { MessageFormatElement } from 'react-intl'
import { TranslationKey } from './index'

const translations:
  | Record<TranslationKey, string>
  | Record<TranslationKey, MessageFormatElement[]> = {
  'aboutus.customers': 'customers',
  'aboutus.employees': 'employees',
  'aboutus.projects': 'investment in sustainable development projects',
  'aboutus.sdg':
    'The organization that meets Sustainable Development Goals of the UN',
  'aboutus.title': 'WELCOME TO MOBICOM GROUP',
  'aboutus.text':
    'Mobicom group is the Mongolian telecommunication and information technology leading company. We provide ICT services such as cellular, and satellite communications, high-speed internet, digital payment solutions, data centers, content and video streaming services, network infrastructure, inter-city and international channel rent services, and digital content to government agencies, enterprises, and individuals. Mobicom group is leading the Digital Transformation and successfully localizing IoT, AI, and 5G technologies in Mongolia.',
  'aboutus.iso1': 'Quality Management Systems',
  'aboutus.iso2': 'Information Security Management Systems',
  'aboutus.iso3': 'Occupational Health and Safety Management Systems',
  'aboutus.subs': 'subsidiaries',
  'aboutus.management.biography': 'Biography',
  'aboutus.management.subsidiaryDirectors': 'CEO of the Group company',
  'aboutus.management.groupDirectors': 'Executive members',
  'apartment.door': 'Door number',
  accept: 'Accept',
  acceptTermsOfService: 'Please accept the terms of service',
  address:
    'Mongolia, Ulaanbaatar city, Sukhbaatar district, 1st courtyard, UNESCO street - 28, MPM Complex',
  'agreement.terms': 'Agreement and terms of service conditions',
  all: 'All',
  amountDue: 'Amount due',
  'app.title': 'The apps will make your life easier',
  apporcard: 'By app or card',
  back: 'Back',
  'bill.back': 'Back to payment',
  'bill.check': 'Check payment balance',
  'bill.mobicom': 'Mobicom payment',
  'bill.mobinet': 'Postpaid Mobinet payment',
  'bill.wifiCard': 'Buy Wifi card',
  'bill.wifiCard.warning':
    'Please enter your phone number to get the wifi card, and you will see the unit cards that can be recharged for that number',
  'bill.Mnp75': 'Postpaid MNP75 payment',
  'bill.Mnp75.warning':
    'Please enter your MNP75 phone number to get the unit, and you will see the unit cards that can be recharged for that number',
  'bill.Voo': 'Postpaid VOO payment',
  'bill.warning': 'It is not possible to make transactions below 1000 MNT',
  billion: 'billion',
  branch: 'branch',
  branches: 'Service branches',
  'branches.type': 'Branch type',
  buy: 'Buy',
  networkCoverageType: 'Network Coverage',
  NetworkCoverageRegion: 'NetworkCoverageRegion',
  city: 'City/Province',
  district: 'Soum/District',
  quarter: 'Khoroo/Bag',
  apartment: 'Buildings',
  bylist: 'By list',
  bymap: 'By map',
  cardOptions: 'Card options',
  ces: 'Comment',
  'ces.reason': 'Leave a comment (Optional)',
  'ces.subtitle':
    'Share your thoughts with us and contribute to further development',
  'ces.title': 'Was it convinient for you to get our service from app?',
  change: 'Change',
  chatGPT_button: 'Chat with AI bot',
  check: 'Check',
  choose: 'Select',
  chooseCard: 'Select recharge cards',
  clickHereToType: 'Click here to type',
  close: 'Close',
  continue: 'Continue',
  confirm: 'Confirm',
  complete: 'Completed',
  creditControl: 'Credit control',
  datakey: 'data',
  'dan.title': 'Customer authentication',
  'dan.invalid_user': 'Customer information does not match',
  'dan.announce':
    'You have to log in to e-mongolia website for authentication purpose',
  'dan.verify': 'To verify',
  'dan.announce.stars':
    "Please log in to your e-Mongolia account and verify that you are the child's parent",
  'dan.requirement':
    'Customer who has Mongolian national identification can use',
  data: 'Data package',
  'data.warning':
    'By entering your data phone number, you can see the available data recharge for that number.\n/Also by entering your Manai Internet number, you can recharge with on-demand data packages./',
  day: 'day',
  days: 'days',
  digitalCard: 'Digital card',
  email: 'E-mail',
  'email.check': 'Please check your email.',
  'email.registration': 'Email registration',
  'email.verification': 'Email verification',
  'email.verification2': 'Verify by email address',
  error: 'Failed',
  'error.addressError': 'Please fill in address information.',
  'error.emailError': 'Email format is incorrect',
  'error.isdnError': 'The phone number is incorrect',
  'error.outstock': 'Out of stock',
  'error.registerError': 'The register number is incorrect',
  'error.requiredFields': 'Please fill in all required fields.',
  'error.requiredFields2': 'Please fill in all required fields.',
  'error.corpRegister.empty': 'Please fill corporate register field.',
  'error.cyrillError': 'Please write the information correctly in Cyrillic.',
  'COX.name': 'Condominium Association Name',
  'COX.contact1': 'Condominium Association phone number',
  'COX.contact2': 'Condominium Association phone number 2',
  registrationExpire: 'Registration expires in',
  expire: 'Expires in',
  'request.toSend': 'Send a request',
  'request.sent': 'Your request has been accepted',
  'request.failed': 'Request failed.',
  'request.success': 'Request successful',
  'request.network': 'New coverage request',
  'request.service': 'Order for Home BroadBand internet',
  'footer.aboutus': 'About us',
  'footer.contact': 'Contact',
  'footer.future': '\nExcited for the future?\n\n',
  'footer.jobs': 'Open vacancies',
  'footer.join': '\nJoin us?\n\n',
  'footer.support': 'Let us help you',
  generalProvs: 'General provisions',
  groupcompanies: 'Group companies',
  'handset.color': 'Color',
  'handset.size': 'Size',
  'handset.specs': 'Technical specifications',
  'handset.storage': 'Storage',
  'handset.title': 'Phones',
  'help.title': 'Do you need help?',
  'legend.legend': 'Legends',
  'legend.wifi': 'Wifi',
  'legend.quality': 'Network quality',
  'legend.good': 'Good',
  'legend.medium': 'Medium',
  'history.timeline': 'History timeline',
  homebroadbandRequest: 'Place an order for home broadband internet',
  homebroadbandWarning:
    'If your property is not in the list above. It means that the network is not included. Please send us your network submission request.',
  'home.development': 'Sustainable development',
  'home.help': 'Help',
  'home.join': 'Join us',
  'home.special': 'Special offers',
  'home.top': 'Top',
  'homeNav.apps': 'Apps',
  'homeNav.offers': 'Offers',
  'homeNav.shop': 'Online shop',
  hour: 'hour',
  infoLanguage: 'Language for Information',
  infoType: 'Method of getting information',
  loading: 'Please wait',
  location: 'Location',
  networktype: 'Network type',
  login: 'Login',
  management: 'Management team',
  'menu.5g': '5G network',
  'menu.advice': 'Advice',
  'menu.news': 'News',
  'menu.registration': 'Registration',
  'menu.promo': 'Promotion',
  'menu.notice': 'Notice',
  'menu.service': 'Service',
  'menu.shop': 'Online shop',
  million: 'million',
  minute: 'minute',
  mobicom: 'MOBICOM CORPORATION',
  mongolian: 'Mongolian',
  month: 'month',
  news: 'News',
  'news.all': 'All news',
  'news.new': 'New',
  'news.read': 'Read more',
  'numberInput.hbb': 'Contract number or username',
  'numberInput.voo': 'Voo number or contract number',
  'number.choose': 'Choose number',
  'number.chosen': 'Phone number',
  'number.deviceList': 'List of devices',
  'number.search': 'Search number',
  'number.available': 'Possible numbers',
  'number.save': 'You have saved the number below. Do you want this number?',
  'number.buyOther': 'Get another number',
  'number.save.title': '12 hours',
  'number.save.description':
    'Please generate your chosen number on a BELEN SIM card within 12 hours, BELEN SIM cards are available at your nearest mobicom authorized dealer and CU chain stores',
  'number.verifyInfo': 'Verify child information',
  'number.sim': 'Activate SIM card',
  'number.sim.guide':
    'Activate the card by entering the 9-digit number before the letter F on the back of the SIM card.',
  'number.success.title': 'The Stars number has been successfully generated',
  'number.success.body': 'Thank you for choosing Mobicom',
  'number.deposit': 'Deposit',
  'number.registrationFee': 'Registration fee',
  'number.simFee': 'Sim fee',
  'number.terms':
    'I have read and agreed to the Agreement and Terms of Services above',
  'number.step1Title': 'Enter your information',
  'number.step1Desc': 'Enter your personal information',
  'number.step2Title': 'Enter your registration',
  'number.step2Desc': 'Confirm your information',
  'number.step3Title': 'Agreed a contract',
  no: 'No',
  noResult: 'No results found',
  notMandatory: 'Not mandatory',
  order: 'Order now',
  'order.create.save.number': 'Enter your phone number to create order',
  'order.confirmed': 'Order confirmed',
  'order.date': 'Order date',
  'order.delivery.address': 'More details',
  'order.delivery.addressInfo': 'Address details',
  'order.delivery.afternoon': '2pm - 8pm',
  'order.delivery.city': 'Province/City',
  clear: 'Clear',
  'order.delivery.delivery': 'Delivery',
  'order.delivery.district': 'Soum/District',
  'order.delivery.division': 'Bag/Khoroo',
  'order.delivery.fee': 'Delivery fee',
  'order.delivery.firstName': 'First name',
  'order.delivery.firstName.error': 'Please insert your first name!',
  'order.delivery.get': 'Deliver',
  'order.delivery.lastName': 'Last name',
  'order.delivery.lastName.error': 'Please insert your last name!',
  'order.delivery.morning': '10am - 2pm',
  'order.delivery.onWay': 'Delivery is on the way',
  'order.delivery.pickup': 'Pickup',
  'order.delivery.registerNo.error':
    'Please insert citizen registration number!',
  'order.delivery.start': 'Start delivery',
  'order.delivery.success': 'Delivered successfully',
  'order.delivery.time': 'Please choose delivery time',
  'order.delivery.title': 'Delivery address',
  'order.empty': 'No order found',
  'order.history': 'Order history',
  'order.information.orderInfo': 'Order information',
  'order.information.user': 'Customer',
  'order.information.userInfo': 'Customer information',
  'order.items': 'Items',
  'order.my': 'My orders',
  'order.notif': 'Checking goods, wait a moment',
  'order.paymentInfo': 'Payment information',
  'order.receive.form': 'Form of receiving the product',
  'order.receive.place': 'Pick up place',
  'order.receive.time': 'Time to pick up the product',
  'order.status': 'Order status',
  'order.summary': 'Order summary',
  'order.totalAmount': 'Total amount',
  'order.vat': 'VAT',
  'openApp.title': 'Get the service you want quickly from the Mobi app',
  'openApp.open': 'Open app',
  'openApp.download': 'Download app',
  others: 'Others',
  our: 'Our',
  call: 'Call',
  package: 'Package',
  'package.choose': 'Select your package',
  'package.viewDetails': 'View details',
  'package.addOnPackage': 'Add-on package',
  'package.addOnPackageDescription':
    'You can additionally select from the following packages',
  'package.usageLimitLevel':
    'Postpaid numbers have no credit control (CC), so please monitor your usage. If you would like to set an CC, please call 2222.',
  packageselection: 'Choose package plan',
  packageshift: 'Package shift',
  'packageshift.currentPackage': 'Current package',
  'packageshift.chooseService': 'Choose service',
  'packageshift.chooseCard': 'Choose your potential transfer package',
  'packageshift.packageType': 'Package type',
  'packageshift.packageTypeDescription':
    'Choose the type of package that suits your needs',
  'packageshift.possiblePackages': 'Available packages to shift',
  'packageshift.info1': 'You can change your package once a month.',
  'packageshift.info2':
    'Your chosen package will be billed based on the day of use.',
  'packageshift.info3':
    "If you have a term contract agreement, your number package can be upgraded within the contract period. However, please note that it can't be downgraded.",
  'packageshift.cation1':
    'Your payment for the old and new package will becalculated on the day of use.',
  'packageshift.cation2':
    'If you have a handset or accessory leasing, please note that it is not possible to choose a package below the package you have made a contract with.',
  'packageshift.cation3':
    "If you have a term contract agreement, your number package can be upgraded within the contract period. However, please note that it can't be downgraded.",
  'packageshift.cation4': 'You can change your package once a month.',
  'packageshift.cation5':
    'Your chosen package will be billed based on the day of use.',
  'packageshift.onlyOnce': 'Sorry, you can change your package once a month.',
  'packageshift.numbersaved':
    'Sorry, you have activated the number keeping service. Hence, it is not possible to change your package.',
  'packageshift.bill_remain':
    'Sorry, it is not possible to change your package because you have a bill remain.',
  'packageshift.unavailable':
    'Sorry, you are currently unable to change your package. Please, call directly to the contact center 2222 or visit the service branch.',
  'packageshift.vipCustomer':
    'Sorry, you cannot change your package with mobicom application. Please, call directly to the contact center 2222 or visit the service branch.',
  'packageshift.credit_limit':
    'Please note that shifting to this package will change your credit control limit to $limit',
  'packageshift.choosen_info': 'Information about your selected package',
  'packageshift.select_package': 'Selected package',
  'packageshift.no_packages':
    "Sorry, you don't have any available packages to shift to.",
  'packageshift.no_mail_info':
    'You can update your registered email address from the profile menu.',
  'packageshift.success':
    'Your request has been sent to the registered email address $email',
  'packageshift.signature': 'Please sign your signature',
  'payment.failed': 'Payment failed.',
  'payment.success': 'Payment success!',
  'payment.pending': 'Payment pending!',
  'payment.thank': 'Thank you for choosing mobicom.',
  'payment.amount': 'Total amount',
  'payment.vat_email': 'VAT sent to your @ email address.',
  'payment.items': 'Order items',
  phoneNumber: 'Phone number',
  'phoneNumber.verification': 'Verify by phone number',
  'phoneNumber.insert': 'Insert phone number',
  'service.select': 'Select service',
  price: 'Price',
  product: 'Product',
  payment: 'Payment',
  paymentAmount: 'Payment amount',
  preorderP1: 'Full payment',
  preorderP2: 'By leasing',
  preorderQ1: 'Please choose the model you will buy',
  preorderQ2: 'Please choose color of the phone you will buy',
  preorderQ3: 'Please choose payment type',
  preorderQ4: 'Which branch will you visit to get your phone',
  preorderQ5: 'Fill your full name and phone number',
  productPrice: 'Product price',
  quickaction: 'Quick action',
  'quick.buyData': 'Buy data',
  'quick.buyWifiCard': 'Buy Wifi card',
  'quick.buyMnp75': 'MNP75 unit',
  'quick.buyUnit': 'Buy unit',
  'quick.homeInternet': 'Mobinet',
  'quick.myInternet': 'Manai internet',
  'quick.newNumber': 'New number',
  'quick.payBill': 'Pay bill',
  'quick.simRecover': 'Sim recovery',
  'quick.wifiCard': 'Wifi card',
  'quick.wifiDevice': 'Wifi devices',
  registerNo: 'Citizen registration number',
  relation: 'Relation',
  required: 'Required',
  'sdg.title': 'Mobicom group for sustainable development',
  'sdg.highlighted': 'Highlighted projects',
  'sdg.others': 'Other projects',
  search: 'Search',
  second: 'second',
  seeLocation: 'See the location',
  'service.additional': 'Additional services',
  'service.general': 'General services',
  'service.internet': 'Internet services',
  'service.mobile': 'Mobile services',
  share: 'Share with others',
  shop: 'Online shop',
  'shop.accessories': 'Accessories',
  'shop.addedToCart': 'Added to cart',
  'shop.address': 'Address',
  'shop.addToCart': 'Add to cart',
  'shop.backToShop': 'Back to shop',
  'shop.brand': 'Brand',
  'shop.buyLeasing': 'Buy with leasing',
  'shop.cart': 'Cart',
  'shop.comparison': 'Compare',
  'shop.deliveryinfo.title':
    'Ordered goods can be delivered anywhere in Ulaanbaatar',
  'shop.deliveryinfo.text':
    'Your item will be delivered within 1-2 business days depending on the delivery location.',
  'shop.emptyCart': 'Your cart is empty',
  'shop.filter': 'Filter',
  'shop.finish': 'Finish',
  'shop.gift': 'Gifts',
  'shop.goToCart': 'Go to cart',
  'shop.hasGift': 'Has gift',
  'shop.hasSale': 'Has sale',
  'shop.internet': 'Internet devices',
  'shop.introduction': 'Details',
  'shop.leasePeriod': 'Lease period',
  'shop.leaseAdvance': 'Prepayment',
  'shop.leaseMonthlyPayment': 'Monthly payment',
  'shop.leasing1':
    'If you are planning to buy a mobile phone on lease terms, you must meet the leasing condition. Check your leasing eligibility by following the instructions below',
  'shop.leasing1.5': 'Text the letter "i" to the number "366"',
  'shop.leasing2':
    'Leasing options are available at your nearest branch or the mobicom.mn website',
  'shop.leasingCondition': 'Leasing condition',
  'shop.leasingRequirement': 'Usage requirement',
  'shop.seeAll': 'See all',
  'shop.smartDevice': 'Smart devices',
  'shop.specification': 'Specification',
  'shop.title': 'Shop',
  'shop.corpEmail': 'Email address for transaction information',
  'shop.vat': 'VAT receipt',
  'shop.vatCons': 'Individual',
  'shop.vatCorp': 'Corporate',
  'shop.vatCorpId': 'ID number',
  'shop.vatEmail': 'E-mail address for receiving VAT',
  'shop.vatEmailError':
    'The email address for receiving VAT receipts is incorrect format',
  'sim.choose': 'Choose sim type',
  'sim.choosen': 'Sim type',
  'sim.connect': 'Connect your SIM card',
  'sim.esim.guide':
    'You can check if your phone supports eSIM by referring to the listed models provided',
  'sim.esim.warning':
    'Generate QR code and activate with smartphone camera or file saved as image',
  'sim.verification': 'Sim verification',
  'sim.qrsent': 'eSim receipt has been sent to your $email email',
  'sim.select_device': 'Select a device',
  'sim.selectType': 'Select SIM type',
  'sim.self': 'Physical sim',
  'sim.self.guide':
    'You can activate your physical SIM by entering the 9 digits before the letter F on the back of the SIM card.',
  'sim.self.warning': 'Install by entering the SIM card number',
  'sim.tan.getagain': 'Get code again ',
  'sim.tan_locked': 'Tan code was entered incorrectly 3 times. Get new code.',
  'sim.tan_creation_locked':
    'TAN code creation locked. Please try again after $.',
  'sim.tan_mismatch': 'TAN code is incorrect',
  'sim.tan_sent': 'A verification code has been sent to your $email address',
  'sim.tan_sent_phone':
    'A verification code has been sent to your $phoneNumber phone number',
  'sim.warning': 'Please select the type of sim card to recover your number',
  simple: 'Simple through smart',
  soon: 'Coming soon',
  sort: 'Sort',
  success: 'Successful',
  stars: 'Stars package',
  'stars.child_info': 'Child information',
  'stars.child_register': "Child's register number",
  'stars.child_email': 'E-mail address/not mandatory/',
  'stars.contact': 'Contact number',
  'stars.relation': 'What is the relation with the child',
  'stars.terms':
    'Please click HERE to read the Terms and Conditions of Service. By clicking the CONTINUE button, you are agreeing to the Terms and Conditions of Service.',
  term1:
    'These terms shall be applied on the basis of the user have read and accepted it before using the site and purchasing from online branch',
  term2:
    'Mobicom Corporation (hereinafter referred to as the organization) and the user will jointly monitor the implementation of these terms of service',
  termMain:
    'Welcome to the official online branch of the Mobicom Corporation. These terms of service will govern your relationship with us to use site and purchase from online branch',
  termsOfService: 'Terms of Service',
  thankyoutext: 'Thank you for choosing Mobicom',
  timeTable: 'Timetable',
  total: 'Total',
  totalPrice: 'Total price',
  'trade-in.chooseDevice': 'Please choose your phone',
  'trade-in.condition': 'Trade-in condition',
  'trade-in.desc':
    'Trade In is: A type of purchase where you trade in an old Apple phone and deduct that price from a new model.',
  'trade-in.question': 'Trade-in',
  type: 'Type',
  unit: 'Unit',
  'user.authentication': 'User authentication',
  'user.confirmInfo': 'Please confirm your registration',
  'unit.warning':
    'Enter your phone number to get the unit, and you will see the unit cards that can be recharged for that number',
  'user_info.confirm': 'Verify your information',
  'user_info.your_info': 'Your information',
  'user_info.nationality': 'Citizen',
  'user_info.surname': 'Surname',
  'user_info.name': 'Name',
  'user_info.register_no': 'Register number',
  'user_info.gender': 'Gender',
  'user_info.date_of_birth': 'Date of birth',
  'vat.options': 'Individual, corporate',
  'vision.mission': 'Mission statement',
  'vision.missiontext':
    'We, Mobicom group realizes the material, mental and intellectual prosperity of its employees and their families, co-creates impressive and precious experience with customers and partners, leads the direction toward an equal and empowered society through advanced business way.',
  'vision.value': 'Value statement',
  'vision.valuetext':
    'We commit to the highest integrity and ethical norms \nWe are empathetic \nWe are innovators \nWe embrace change and make it an opportunity',
  'vision.vision': 'Vision statement',
  'vision.visiontext':
    'We will be a trusted partners of everyone by co-creation of values through continuous innovation',
  yes: 'Yes',
  yourcart: 'In your cart',
  'appPrompt.desc':
    'Mobicom products and services can be obtained from your mobile phone as quickly as possible.',
  'appPrompt.open': 'Open app',
  'appPrompt.stay': 'Stay on web',
  'digitalContent.terms': 'Terms of digital consent',
  'digitalContent.term1':
    '1. The user agrees to control the relationships pertaining to using the Mobicom Group company services via digital channels (the Mobicom application & the Mobicom.mn website).',
  'digitalContent.term2':
    '2. The user must register their own official email address and read and agree these terms and conditions in order to get services through Mobicom Group`s digital channels.',
  'digitalContent.term3':
    '3. By accepting this clause, the user consents to utilizing a password, a phone number registered in their own name, a one-time password to an e-mail address that has been confirmed, and a digital signature to access services online.',
  'digitalContent.term4':
    '4. The parties acknowledge and agree that the agreements and contracts made are valid for the services acquired through the means detailed in the third section of these terms and conditions.',
  'digitalContent.term5':
    '5. The user agrees to keep the confidentiality of personal information private and not use or disclose to third parties with your own registered email address or phone number. User assumes all liability for any failure to adhere to this duty.',
  'digitalContent.term6':
    '6. Mobicom Group companies have the responsibility for the protection of user data on their digital channels as well as the veracity of the information they provide regarding goods and services.',
  'digitalContent.term7':
    'The Service Agreement and any Terms of Service shall govern matters not expressly included by these Terms.',
  logoElement: 'Logo element',
  logoSpace: 'Logo space',
  logoText: 'Text',
  logoColor: 'Color palette',
  logoDownload: 'Download logo',
  guideDownload: 'Download guide',
  logoColorDesc:
    'The Mobicom brand color is essential for conveying a cohesive and recognizable image. "Mobicom red" is our signature color, embodying the essence of the Mobicom style for our customers',
  logoTextDesc: 'The name of the company is written as follows.',
  logoSpaceDesc:
    'To display the Mobicom logo with clarity and distinction, please adhere to the minimum protected area defined below. Always aim to provide as much protection area (margin) as possible when displaying the logo.',
  logoElementDesc:
    'The "Mobicom brand logo" is central to our identity, representing  Mobicom as a corporate brand, a business brand, and a group.',
  logoTitle: 'Instructions for using the Mobicom logo',
  logoDesc:
    'This logo is the main element of the Mobicom brand. We provide logo usage guidelines to ensure consistent and accurate branding. These guidelines are intended to ensure appropriate and correct use of the logo across all platforms and materials.',
  copy: 'copied',
  logoWarning:
    'To ensure proper usage of the Mobicom logo, please follow these guidelines:',
  logowarningDesc1: 'Do not change the logo`s element, or size.',
  logowarningDesc2: 'Do not change the logo`s colors.',
  logowarningDesc3: 'Do not add effects.',
  logowarningDesc4: 'Do not rotate the logo.',
  logowarningDesc5:
    'By following these guidelines, you help us maintain a strong and consistent brand identity. Thank you for your cooperation!',
  logowarningTitle: 'Logo usage device',
  logoBack: 'Mobicom logo background',
  logoDontUse: 'Helpful reminders for using the logo',
  logoDontuseDesc1: 'Do not use the logo without proper opacity or gradient.',
  logoDontuseDesc2:
    'Avoid placing the logo in a cluttered or disorganized layout',
  logoDontuseDesc3: 'Do not alter the brand logo`s font.',
  logoDontuseDesc4: 'Maintain the correct aspect ratio of the logo.',
  logoDontuseDesc5: 'Avoid adding shadows to the logo.',
  logoDontuseDesc6: 'Do not change the logo`s background color.',
  logoDontuseDesc7: 'Do not use the wrong logo color on dark backgrounds.',
  logoDontuseDesc8: 'Avoid using incorrect logo colors on bright backgrounds.',
  logoDontuseDesc9:
    'Using a white logo on a background color other than the primary red color of the brand.',
  roamingCountry: 'Country',
  roamingRegion: 'Region',
  roamingDomesticCall: 'Domestic Call',
  roamingToMongolia: 'To mongolia',
  roamingOtherCounties: 'Other countries',
  roamingIncomingCalls: 'Incoming calls',
  roamingOffnetMessage: 'Off-net Message',
  roamingVolume: 'Volume',
  roamingDuration: 'Duration',
  roamingSpeed: 'Speed',
  roamingTariff: 'Tariff',
  roamingType: 'Volume',
  roamingDataPackage: 'Data Package',
  roamingSms: 'SMS Package',
  roamingDesc:
    'It is a service that allows you to travel abroad with your mobile phone and use it freely.',
  roamingService: 'Roaming service',
  roamingSearch: 'Search',
  roamingEmbassy: 'Click here for embassy contact details',
  phoneNumbers: 'Phone number',
  referralPromoCode: 'Promo code',
  referralCodeActivate: 'Activate',
  referralCodeNotValid: 'Referral code not found.',
  cooperationCompany: 'Company',
  cooperationCitizen: 'Citizen',
  'sort.priceAsc': 'Price asc',
  'sort.priceDesc': 'Price desc',
  'sort.result': 'result',
  'shop.maximum': 'Maximum',
  'shop.minimum': 'Minimum',
  'sort.default': 'Priority',
  'shop.location': 'Buy on lease from a branch near you.',
  'shop.state': 'State',
  'shop.leasing2.5':
    'If you purchase on lease, the price of the device will be calculated with the original price.',
  'quick.leasing': 'Loan Assesment',
  'leasing.step1Title': 'Verification',
  'leasing.step1Desc': 'Sign-up',
  'leasing.step2Title': 'e-Mongolia',
  'leasing.step2Desc': 'Confirmation, download information',
  'leasing.step3Title': 'CIB',
  'leasing.step3Desc': 'Confirmation, download information',
  'leasing.step1TextTitle': 'Mobicom user',
  'leasing.step1TextDesc': 'User with mobicom number',
  'leasing.step1TextTitle2': 'New user',
  'leasing.step1TextDesc2': 'User with a different operator',
  'leasing.eMongoliaconfirm': 'E-Mongolia Verification.',
  'leasing.eMongoliaText':
    'We are about to log into the \ne-mongolia system to verify your identity',
  'leasing.tan_sent': 'Verification code is sent to your \n$email e-mail.',
  'leasing.sent_phone':
    'Verification code has been sent to your \n$phoneNumber number.',
  'leasing.vat': '',
  'leasing.warning':
    'If your email address is incorrect, please update it through the Mobicom application.',
  quickaction1: 'Internet action',
  'leasing.reference': 'CIB',
  'leasing.referenceDet':
    'By proceeding, you authorize us to request and review \nyour credit report from the Credit Information Bureau \n(CIB) as part of of the service evaluation process.',
  'leasing.blacklist.title': 'Notice',
  'leasing.blacklist.description':
    'Sorry, you are not eligible for this service as \nyou are listed on the blacklist.',
  'leasing.underage.title': 'Age restriction',
  'leasing.underage.description':
    'Sorry, this service is only available \nto users aged 18 and above.',
  'leasing.dan_url_missing': 'Dan url not found',
  'leasing.fail': 'I understand',
  'leasing.info': '',
  'leasing.info.benefit': 'Loan without fees. Guaranteed. Flexible Options.',
  'leasing.info.benefit1':
    'Get the smartphone of your choice with loan without fees with a customized plan tailored to your needs.',
  'leasing.info.benefit_terms': 'Leasing Terms:',
  'leasing.info.benefit_terms1': 'Loan terms: 6, 12, or 24 months',
  'leasing.info.benefit_terms2': 'Down payment options: 0%, 10%, or 35%',
  'leasing.info.termsofservice': 'Terms of service',
  'leasing.info.termsofservice1':
    'The service is available to users aged 18 and above.',
  'leasing.info.termsofservice2':
    'The Leasing eligibility assessment costs 2,000 MNT (VAT included) and is valid for 24 hours.',
  'leasing.info.termsofservice3':
    'The calculated amount reflects only the monthly repayment ability.',
  'leasing.info.termsofservice4':
    'You can proceed with device leasing by visiting your nearest Mobicom branch.',
  'leasing.info.month': 'Validity period',
  'leasing.info.monthPay': 'Monthly payment',
  'leasing.info.date': 'Valid date',
  'leasing.info.consumer': 'Consumer',
  'leasing.info.consumer1': 'Please provide one of the following documents:',
  'leasing.info.consumer2': 'National ID card',
  'leasing.info.consumer3': 'National ID verification certificate',
  'leasing.info.consumer4': 'E-Mongolia OTP',
  'leasing.info.consumer5': 'GSign authentication',
  'leasing.info.corporate': 'Corporate user',
  'leasing.info.corporate1':
    'Official Letter (must include the following information):',
  'leasing.info.corporate2':
    'Full name, registration number, and contact number of the employee applying for the device leasing, Signature of the Executive Director and the official company seal',
  'leasing.info.corporate3': 'Device type, upfront fee, and loan term.',
  'leasing.info.corporate4':
    'Identification document of the representative employee:',
  'leasing.info.corporate5': 'National ID card',
  'leasing.info.corporate6': 'National ID verification certificate',
  'leasing.info.corporate7': 'E-Mongolia OTP',
  'leasing.info.corporate8': 'GSign authentication',
  'leasing.info.location': 'Visit branch',
  'leasing.info.location1':
    'Customers are required to visit a Mobicom branch to proceed with the loan service.',
  'leasing.confirmzms.title': 'Success',
  'leasing.confirmzms.description':
    'Please request your credit information \nfrom the credit data base.',
  'leasing.step4Title': 'Calculate leasing',
  'leasing.step4Desc': 'Confirmation, leasing information',
  'leasing.confirzms.button': 'Get credit inquiry',
  'leasing.successzms.title': 'Leasing Calculation in Progress',
  'leasing.successzms.description':
    'Leasing eligibility is calculating, confirmation \ninformation will be sent to your registered email \naddress. Please wait.',
  'leasing.nomail':
    'Your e-mail isn’t registered. Please register your \ne-mail address to continue.',
  'leasing.verification_failed.title': 'Notice',
  'leasing.verification_failed.description':
    'We’re sorry, we couldn’t retrieve your information from the \nSocial Insurance system. Try again',
  'leasing.corpError.title': 'Notice',
  'leasing.corpError.description':
    'Sorry, this service is not available. Please \ncontact 2222 and the service branch',
  'error.configuratorDataMissing': 'An error occurred, Please try again.',
  'leasing.confirmzms.web.title': 'Credit Information Bureau',
  'leasing.confirmzms.web.description':
    'By proceeding, you authorize us to request and review your credit report from the Credit Information Bureau (CIB) as part of of the service evaluation process.',
  'leasing.confirmzms.button': 'Confirm',
  'leasing.corp.fail':
    'Sorry, we are unable to determine your loan eligibility at this time. \nPlease visit the Mobicom app or Service branch.',
  'leasing.register.email':
    'Your e-mail isn’t registered. Please register your \ne-mail address to continue.',
  'leasing.dan.fail.title': 'Notice',
  'leasing.dan.fail.description':
    'We’re sorry, we couldn’t retrieve your information from the \nSocial Insurance system. Try agai',
  'leasing.pending.title': 'Calculating your credit eligibility',
  'leasing.pending.description':
    'Please wait and attend to your other \ntasks while we finish calculating \nyour credit eligibility.',
  'leasing.verification_failed.button': 'Try again',
  'leasing.complete.text1':
    'Loan without fees. Guaranteed. Flexible Options. Get the smartphone of your choice with loan without fees with a customized plan tailored to your needs',
  'leasing.complete.text2':
    'You can view detailed information on how to get a loan from the terms of service.',
  'leasing.complete.usedAmount': 'Used Amount',
  'leasing.complete.Amount': 'Amount',
  'quick.mnp75': 'MNP75',
  'leasing.register.mismatch.title': 'Notice',
  'leasing.register.mismatch.description':
    'Your phone number does not match the information \nregistered in the E-Mongolia system. For further \nassistance, please contact the 2222 call center or \nvisit the nearest customer service center.',
  'tourist.title': 'Tourist data SIM',
  'tourist.simple': 'Simple through smart',
  'tourist.plans': 'Plans',
  'tourist.plans.subtitle': 'Choose your preferred package',
  'tourist.payment': 'Payment',
  'tourist.choosePackage': 'Choose package plan',
  'tourist.packages': 'Packages',
  'tourist.email': 'E-mail',
  'tourist.email.register': 'E-mail registration',
  'tourist.continue': 'Continue',
  'tourist.simtype': 'Choose SIM type',
  'tourist.selfsim': 'Physical SIM',
  'tourist.selfsim.subtitle':
    'Activate by entering the SIM card number (ICCID) manually.',
  'tourist.selfsim.number': 'SIM card number',
  'tourist.selfsim.desc':
    'You can activate your physical SIM by entering the 9-digit number found before the letter “F” on the back of your SIM',
  'tourist.selfsim.warning':
    'Physical SIM cards are available at Mobicom branches and selected CU and GS25 convenience stores.',
  'tourist.esim': 'eSIM',
  'tourist.esim.desc':
    'Activate using a QR code scanned with your smartphone camera or uploaded as an image.',
  'tourist.esim.phonelist': 'Compatible model list',
  'tourist.esim.choose': 'Choose your device',
  'tourist.esim.info1':
    'To confirm eSIM compatibility please check your device from the provided model list.',
  'tourist.esim.info2': '“Settings -> Cellular -> Add Cellular plan”',
  'tourist.order.summary': 'Order summary',
  'tourist.single.package': 'Package',
  'tourist.price': 'Price',
  'tourist.payment.method': 'Payment method',
  'tourist.credit.card': 'Credit / Debit card',
  'tourist.pay': 'Pay',
  'tourist.tan.again': 'Get new code',
  'tourist.tan.': 'Packages',
  'tourist.choose': 'Choose SIM type',
  'tourist.choosen': 'SIM type',
  'tourist.connect': 'Connect your SIM card',
  'tourist.esim.guide':
    'You can check if your phone supports eSIM by referring to the listed models provided',
  'tourist.esim.warning':
    'Generate QR code and activate with smartphone camera or file saved as image',
  'tourist.verification': 'Sim verification',
  'tourist.qrsent': 'eSim receipt has been sent to your $email email',
  'tourist.select_device': 'Select a device',
  'tourist.selectType': 'Select SIM type',
  'tourist.self': 'Physical SIM',
  'tourist.self.guide':
    'You can activate your physical SIM by entering the 9-digit number found before the letter "F" on the back of your SIM card.',
  'tourist.self.warning': 'Install by entering the SIM card number',
  'tourist.tan.getagain': 'Get code again ',
  'tourist.tan_locked':
    'Tan code was entered incorrectly 3 times. Get new code.',
  'tourist.tan_creation_locked':
    'TAN code creation locked. Please try again after $.',
  'tourist.tan_mismatch': 'TAN code is incorrect',
  'tourist.tan_sent':
    'A verification code has been sent to your $email address',
  'tourist.tan_sent_phone':
    'A verification code has been sent to your $phoneNumber phone number',
  'tourist.warning':
    'Please select the type of SIM card to recover your number',
  'tourist.success': 'Registration successful',
  'tourist.success.desc':
    'Your SIM is ready for installation. Please insert it into your phone. Your phone number will be sent to your registered email shortly.',
  'tourist.recharge': 'Recharge',
  'tourist.number': 'Phone number',
  'tourist.number.enter': 'Enter your phone number',
  'tourist.number.find':
    'You can find your phone number in the email you received after activating your SIM.',
  'tourist.change': 'Change',
  'tourist.select': 'Select',
  'tourist.back': 'Back',
  'tourist.days': 'days',
  'tourist.day': 'day',
  'tourist.request.failed': 'Request failed.'
}

export default translations
